// the desired points between each divider
const targetPointsPerDivider = 84
const targetPointsPerLabel = 92

// the acceptable vertical divisions of the x axis
const divisionsInHours = [
  5 / 60,
  10 / 60,
  15 / 60,
  30 / 60,
  1,
  2,
  3,
  6,
]

type ReturnType = {
  hoursPerDivider: number;
  dividersPerTimeLabel: number; // this will be 1, 2, or 3
}

/*
 * returns duration in hours between each vertical line that divides the x axis
 */
export function pointsPerHourToHoursPerDivider(
  pointsPerHour: number,
): ReturnType {
  const hoursPerDivider = divisionsInHours.reduce(
    (nearestDivision, nextDivision) => {
      // difference in points between nearestDivision and target
      const nearestDiff = Math.abs(
        targetPointsPerDivider - nearestDivision * pointsPerHour,
      )

      // difference in points between nextDivision and target
      const nextDiff = Math.abs(
        targetPointsPerDivider - nextDivision * pointsPerHour,
      )

      if (nextDiff <= nearestDiff) {
        return nextDivision
      }

      return nearestDivision
    },
    divisionsInHours[0],
  )

  const pointsPerDivider = hoursPerDivider * pointsPerHour
  const hideSomeTimeLabels = pointsPerDivider < targetPointsPerLabel

  const dividersPerTimeLabel = hideSomeTimeLabels
    ? hoursPerDivider === 10 / 60 || hoursPerDivider === 5 / 60
      ? 3
      : 2
    : 1

  return {
    hoursPerDivider,
    dividersPerTimeLabel,
  }
}
